import React, { useEffect, useState } from "react";
import { useLang } from "@/lib/i18n-context";

const TARGET = new Date("2026-12-12T09:00:00+09:00").getTime();

function getRemaining() {
  const now = Date.now();
  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default function Countdown() {
  const { t } = useLang();
  const [r, setR] = useState(getRemaining());
  useEffect(() => {
    const id = setInterval(() => setR(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);
  const cell = "flex flex-col items-center justify-center bg-white/10 backdrop-blur-md border border-white/25 rounded-2xl px-4 py-4 md:px-6 md:py-5 min-w-[72px] md:min-w-[100px]";
  return (
    <div className="flex gap-3 md:gap-4" data-testid="countdown">
      {[
        [r.days, t("countdown_days")],
        [r.hours, t("countdown_hours")],
        [r.minutes, t("countdown_min")],
        [r.seconds, t("countdown_sec")],
      ].map(([val, label], i) => (
        <div key={i} className={cell}>
          <div className="font-display text-3xl md:text-5xl font-bold text-white tabular-nums leading-none">
            {String(val).padStart(2, "0")}
          </div>
          <div className="text-[10px] md:text-xs uppercase tracking-widest text-white/80 mt-2">
            {label}
          </div>
        </div>
      ))}
    </div>
  );
}
